export default {
  cam: () => import("/builds/david.s/LocalinoHubItemSpotter/src/layouts/cam.vue"),
  default: () => import("/builds/david.s/LocalinoHubItemSpotter/src/layouts/default.vue")
}